import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import theme from 'theme/index';
import {
  getInheritedPermissionsForObjectIdentityId,
} from 'auth/store/permissions/selectors';
import {
  updatePermission,
  deletePermission,
} from 'auth/store/permissions/actions';
import Tag from 'base/components/Tag';


class DefaultPermissionToggle extends Component {
  handleClick = () => {
    const { readOnly } = this.props;
    if (readOnly) {
      return;
    }
    const {
      permissions, objectIdentityId, updatePermission, deletePermission,
    } = this.props;

    if (permissions.isInherited) {
      // override default -> copy inherited permissions onto this objectIdentity
      updatePermission({
        ...permissions,
        objectIdentityId,
      });
    } else {
      // reset to default -> remove permissions on this objectIdentity / sid
      deletePermission(permissions);
    }
  };


  render() {
    const { permissions, readOnly } = this.props;
    const style = {
      margin: '0 15px',
      background: theme.colors.light,
    };
    if (permissions && permissions.isInherited) {
      style.background = theme.colors.primary;
      if (readOnly) {
        style.background = theme.colors.darker;
      }
    }

    return (<Tag style={style} onClick={this.handleClick}>from parent</Tag>);
  }
}
DefaultPermissionToggle.propTypes = {
  updatePermission: PropTypes.func.isRequired,
  deletePermission: PropTypes.func.isRequired,
  permissions: PropTypes.objectOf(PropTypes.any).isRequired,
  objectIdentityId: PropTypes.number.isRequired,
  readOnly: PropTypes.bool,
};
DefaultPermissionToggle.defaultProps = {
  readOnly: false,
};


const mapStateToProps = (state, props) => ({
  permissions: getInheritedPermissionsForObjectIdentityId(state, props.objectIdentityId),
});

const mapDispatchToProps = {
  updatePermission,
  deletePermission,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefaultPermissionToggle);
